"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConstructor = void 0;
exports.isConstructor = (value) => !!value.prototype && !!value.prototype.constructor.name;
//# sourceMappingURL=is-constructor.js.map